import { render, staticRenderFns } from "./parentAdd.vue?vue&type=template&id=035e66f2&scoped=true&"
import script from "./parentAdd.vue?vue&type=script&lang=js&"
export * from "./parentAdd.vue?vue&type=script&lang=js&"
import style0 from "./parentAdd.vue?vue&type=style&index=0&id=035e66f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035e66f2",
  null
  
)

export default component.exports